import React from "react";
import { RootStateOrAny, useSelector, useDispatch } from "react-redux";
import { Panel } from "office-ui-fabric-react";
import { useTranslation } from "react-i18next";

import { panelS } from "../../common/styles/panelStyles";
import { toggleAdminsPanel } from "../../../config/redux/admins/adminsActions";
import AdminForm from "./AdminForm";



const AdminPanel: React.FC = () => {
  const { t } = useTranslation("admin");
  const dispatch = useDispatch();
  const { adminsPanelOpen } = useSelector(
    (state: RootStateOrAny) => state.admins
  );

  const dismissPanel = () => {
    dispatch(toggleAdminsPanel({ open: false }));
  };



  return (
    <Panel
      isOpen={adminsPanelOpen}
      closeButtonAriaLabel={t("nav.close") as string}
      headerText={t("nav.panelAdministrator") as string}
      onDismiss={dismissPanel}
      type={1}
      styles={panelS}
      isHiddenOnDismiss={false}
    >
      <AdminForm />
    </Panel>
  );
};

export default AdminPanel;